import { render } from "./ErrorLogout.vue?vue&type=template&id=477b55a6"
import script from "./ErrorLogout.vue?vue&type=script&lang=js"
export * from "./ErrorLogout.vue?vue&type=script&lang=js"
script.render = render

export default script